define('v3/Common/Services/Backend/subjectBackend',[
	'jquery',
	'BackendBase'
], function ($, BackendBase) {
	function SubjectBackend () {
		BackendBase.call(this);
	};

	SubjectBackend.prototype = $.extend({}, BackendBase.prototype);

	$.extend(SubjectBackend.prototype, {

		getSubjectsWhereEducationPlanExistsForClass: function () {
			return this._getJsonApi('Subjects/EducationPlanExistsForClass');
		},
		getSubjectsAvailableForClass: function () {
			return this._getJsonApi('Subjects/AvailableForClass');
		},
		getPupilPercentilesPerSubjectGroup: function (pupilId) {
			return this._getJsonApi('Boundaries/SubjectGroupsSubjectCurrentPercentilesForPupil/' + pupilId);
		}
	});

	return new SubjectBackend();
});

